export interface IAnnualReportTemplateSettings {
    uncoveredShortfall?: boolean | null;
    showShareholderInfo?: boolean | null;
}
